module.exports = __webpack_public_path__ + "img/login_bg.26440f61.png";